// NodeTypeChip — a node type's name as a chip in its palette fill and ink.
// Single source: styleResolver (topology styles over the COADA NDD defaults),
// so overlay/panel badges always match the tile on the canvas.

import { useSelector } from 'react-redux';
import { selectNodeTypeStyles } from '../../store/slices/topologySlice.ts';
import { resolveNodeInk, resolveNodeStyle } from '../../services/styleResolver.ts';

export default function NodeTypeChip({
  type,
  label,
  className = '',
}: {
  type: string;
  /** Text shown; defaults to the raw node type. */
  label?: string;
  className?: string;
}) {
  const styles = useSelector(selectNodeTypeStyles);
  const style = resolveNodeStyle(type, styles);
  return (
    <span
      className={`node-type-chip ${className}`.trim()}
      data-testid="node-type-chip"
      data-node-type={type}
      style={{ background: style.fill, color: resolveNodeInk(style) }}
    >
      {label ?? type}
    </span>
  );
}
